export enum GoogleSitesDetailOrderingEnum {
  AreaName = 'areaName',
  LastCopiedDate = 'dateLastSent',
}
